import cn from 'classnames';
import { Divider } from '@react-md/divider';
import { withBaseErrorBoundary } from '@components/error-boundaries';
import { BackLink } from '@components/link';
import { Pagination } from '@components/pagination';
import { PreloaderBox } from '@components/preloader';
import { UserPurchaseTemplate, useInventoryPurchaseTemplatesListQuery } from '@services/df/inventory';
import { useQuotationListeners } from '@modules/quotation/listeners';
import { useGetResizeRef } from '@utils/parant-site-comunicator';
import { composeNodeId } from '@utils';
import { InventoryHeader } from './inventory-header';
import { InventoryBody } from './inventory-body';
import { InventoryFooter } from './inventory-footer';
import { RootPrefix, InventoryPageSize } from './constants';
import { useInventoryFilters } from './hooks';

import styles from './inventory-page.module.scss';

const defaultList: UserPurchaseTemplate[] = [];

const Page = () => {
    const { params } = useInventoryFilters();
    const { data, isLoading, isFetching, total } = useInventoryPurchaseTemplatesListQuery(params, {
        // refetchOnMountOrArgChange: true,
        selectFromResult: ({ data, isLoading, isFetching }) => ({
            data: data?.results ?? defaultList,
            total: data?.count ?? 0,
            isLoading,
            isFetching,
        }),
    });

    const containerRef = useGetResizeRef();

    useQuotationListeners();

    return (
        <div id={RootPrefix} className={styles.layout} ref={containerRef}>
            <div className="container">
                <BackLink id={composeNodeId(RootPrefix, 'back', 'link')} />

                <PreloaderBox show={isLoading}>
                    <div className={cn('rounded-box', styles.box)}>
                        <InventoryHeader />
                        <InventoryBody data={data} />
                        <Divider />
                        <InventoryFooter />
                    </div>
                </PreloaderBox>
            </div>

            <Pagination totalCount={total} pageSize={InventoryPageSize} wrap />
        </div>
    );
};

export const WidgetInventoryPage = withBaseErrorBoundary(Page);
